
import { Watch, Mixins, Component, ProvideReactive } from "vue-property-decorator";
import FourNurse from "./components/fourNurse.vue";
import FourMedicine from "./components/fourMedicine.vue";


@Component({ name: 'fourCombine-index',
  inject: [],
  components: { FourNurse, FourMedicine }
})
export default class FourCombineIndex extends Mixins() {
    @ProvideReactive() currentTab = "1";
}

